import { render } from "./answer.vue?vue&type=template&id=5a7d16da&scoped=true"
import script from "./answer.vue?vue&type=script&lang=js"
export * from "./answer.vue?vue&type=script&lang=js"

import "./answer.vue?vue&type=style&index=0&id=5a7d16da&lang=scss&scoped=true"
import "./answer.vue?vue&type=style&index=1&id=5a7d16da&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7d16da"]])

export default __exports__